import { TextField } from '@celltrak/ui-components';

import withIsolatedInput from './withIsolatedInput';

const IsolatedTextField = withIsolatedInput(TextField);

const fieldTypes = props => ({
  text: <IsolatedTextField {...props} />,
});

export default fieldTypes;
